import { render, staticRenderFns } from "./clientAdmin.vue?vue&type=template&id=48ff203a&scoped=true&"
import script from "./clientAdmin.vue?vue&type=script&lang=js&"
export * from "./clientAdmin.vue?vue&type=script&lang=js&"
import style0 from "./clientAdmin.vue?vue&type=style&index=0&id=48ff203a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ff203a",
  null
  
)

export default component.exports